import React from "react";
import { makeStyles } from "@mui/styles";
import SvgIcon from "@mui/material/SvgIcon";
import { SimpleTreeView } from "@mui/x-tree-view";

function MinusSquare(props) {
  return (
    <SvgIcon fontSize="inherit" {...props} color="secondary">
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 11.023h-11.826q-.375 0-.669.281t-.294.682v0q0 .401.294 .682t.669.281h11.826q.375 0 .669-.281t.294-.682v0q0-.401-.294-.682t-.669-.281z" />
    </SvgIcon>
  );
}

function PlusSquare(props) {
  return (
    <SvgIcon fontSize="inherit" {...props} color="primary">
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 12.977h-4.923v4.896q0 .401-.281.682t-.682.281v0q-.375 0-.669-.281t-.294-.682v-4.896h-4.923q-.401 0-.682-.294t-.281-.669v0q0-.401.281-.682t.682-.281h4.923v-4.896q0-.401.294-.682t.669-.281v0q.401 0 .682.281t.281.682v4.896h4.923q.401 0 .682.281t.281.682v0q0 .375-.281.669t-.682.294z" />
    </SvgIcon>
  );
}

function CloseSquare(props) {
  return (
    <SvgIcon
      className="tree-close"
      fontSize="inherit"
      {...props}
      color="disabled"
    >
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M17.485 17.512q-.281.281-.682.281t-.696-.268l-4.12-4.147-4.12 4.147q-.294.268-.696.268t-.682-.281-.281-.682.294-.669l4.12-4.147-4.12-4.147q-.294-.268-.294-.669t.281-.682.682-.281.696 .268l4.12 4.147 4.12-4.147q.294-.268.696-.268t.682.281 .281.669-.294.682l-4.12 4.147 4.12 4.147q.294.268 .294.669t-.281.682zM22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0z" />
    </SvgIcon>
  );
}

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    padding: "1px",
  },
});

const getParentId = (nameId, nodes, arr) => {
  if (nodes) {
    nodes.forEach((node) => {
      if (node.children && node.children.length > 0) {
        if (node[nameId]) arr.push(node[nameId]);
        getParentId(nameId, node.children, arr);
      }
    });
  }
};

const getAllParentId = (nameId, nodes, isTopParent) => {
  if (nodes) {
    let arr = [];
    getParentId(nameId, nodes, arr);
    return arr;
  }
  return [""];
};

export default function CustomTreeView(props) {
  const classes = useStyles();
  const {
    children,
    nameId,
    data,
    expandAll,
    onNodeToggle,
    expanded,
    selected,
    onNodeSelect,
    disableSelection = true,
    multiSelect = true,
  } = props;
  return (
    <SimpleTreeView
      multiSelect={multiSelect}
      disableSelection={disableSelection}
      className={classes.root}
      defaultCollapseIcon={<MinusSquare />}
      defaultExpandIcon={<PlusSquare />}
      defaultEndIcon={<CloseSquare />}
      expandedItems={expanded || getAllParentId(nameId, data)}
      defaultExpandedItems={expandAll && getAllParentId(nameId, data, true)}
      onExpandedItemsChange={(e, itemIds) =>
        onNodeToggle && onNodeToggle(e, itemIds)
      }
      onItemClick={(e, itemId) => onNodeSelect && onNodeSelect(e, itemId)}
      selectedItems={selected}
    >
      {children}
    </SimpleTreeView>
  );
}
